import { BasePalette, Palette } from './color-palette';
import { TextDirection } from './text-direction';

export interface Theme {
  /** @deprecated use the helper functions instead of direct access, like baseColor, primaryColor, etc... */
  color: {
    base: BasePalette;
    primary: Palette;
    secondary: Palette;
    accent: Palette;
  };
  font: {
    normal: string;
    primary: string;
    secondary?: string;
    tertiary?: string;
    accent?: string;
    accentBody?: string;
    commonIcons?: string;
  };
  fontSize: {
    smaller?: number;
    small: number;
    normal: number;
    big: number;
    bigger?: number;
    large: number;
    extraLarge: number;
    huge: number;
  };
  /** @deprecated use the helper functions instead of direct access */
  breakPoint: {
    smallMobile?: number;
    mediumMobile?: number;
    mobile: number;
    phablet?: number;
    tablet: number;
    smallDesktop: number;
  };
  direction: TextDirection;
  currentDirection: TextDirection;
}

export type ThemeFunction = (p: { theme: Theme }) => string | number | undefined;
type ColorThemeFunction = (colorPaletteIndex: number) => ThemeFunction;

export const customColor = (c: string) => c;

export const baseColor: ColorThemeFunction = (c) => (p) => p.theme.color.base[c];
export const primaryColor: ColorThemeFunction = (c) => (p) => p.theme.color.primary[c];
export const secondaryColor: ColorThemeFunction = (c) => (p) => p.theme.color.secondary[c];
export const accentColor: ColorThemeFunction = (c) => (p) => p.theme.color.accent[c];

export const mobile: ThemeFunction = (p) => p.theme.breakPoint.mobile;
export const smallMobile: ThemeFunction = (p) => p.theme.breakPoint.smallMobile;
export const mediumMobile: ThemeFunction = (p) => p.theme.breakPoint.mediumMobile;
export const phablet: ThemeFunction = (p) => p.theme.breakPoint.phablet || p.theme.breakPoint.tablet;
export const tablet: ThemeFunction = (p) => p.theme.breakPoint.tablet;
export const smallDesktop: ThemeFunction = (p) => p.theme.breakPoint.smallDesktop;

export const normalFont: ThemeFunction = (p) => p.theme.font.normal;
export const primaryFont: ThemeFunction = (p) => p.theme.font.primary;
export const secondaryFont: ThemeFunction = (p) => p.theme.font.secondary;
export const tertiaryFont: ThemeFunction = (p) => p.theme.font.tertiary;
export const accentFont: ThemeFunction = (p) => p.theme.font.accent;
